<template>
	<div class="page-content">
		<!-- 列表 -->
		<div class="lists">
			<nut-infiniteloading @loadmore="onInfinite" :has-more="isHasMore" :is-loading="isLoading" :unload-more-txt="'没有更多了'" :is-show-mod="true">
			    <div v-if="collectionList && collectionList.length > 0">
					<div class="list" @click="routerToDetail(collection.store_id)" v-for="collection in collectionList" :key="collection.id" >
						<SchoolItem :width="'120px'" :height="'90px'" :store-detail=collection></SchoolItem>
					</div>
					<!-- 根据ui自定义没有更多了样式 -->
					<!-- <div class="no-more-data">
						<div class="line-left"></div>
						<span>没有更多了</span>
						<div class="line-right"></div>
					</div> -->
				</div>
				<div v-else>
					<empty></empty>
				</div>
			</nut-infiniteloading>
		</div>
	</div>
</template>

<script>
import SchoolItem from '@/components/SchoolItem'
import empty from '@/views/Empty'
export default {
	name: 'MyCollection',
	components: {SchoolItem, empty},
	data() {
		return {
      		isHasMore: true, //是否有更多数据可以分页滚动
			isLoading: false, //是否展示加载中动画
			collectionList: [],
			page: 1,
			pageSize: 10,
    	}
	},
	created () {
		this.getCollectionList();
	},
	methods: {
		// 分页请求
		onInfinite() {
			this.isLoading = true;
			this.page ++;
			this.getCollectionList();
		},
		/**
		 * 跳转驾校详情
		 * @param {number} id - 驾校id
		 */
		routerToDetail(id) {
			this.$router.push({ name: 'StDetail', query: { id: id }});
		},
		getCollectionList() {
			this.$ajax.get('m/getlist/userCollection', {'activity_id': this.$ajax.get_activity_id(), 'page': this.page, 'page_size': this.pageSize}).then(res => {
				if (res.length > 0) {
					this.collectionList = this.collectionList.concat(res);
				}
				if (res.length < this.pageSize) {
					this.isHasMore = false;
				}
				this.isLoading = false;
			});
		}
	},
  mounted() {
	  window.document.title='我的收藏';
	  setTimeout(()=>{
      window.document.title='我的收藏';
    },1500);
    setTimeout(()=>{
      window.document.title='我的收藏';
    },3000);
  }
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		.lists {
			width: 100%;
			box-sizing: border-box;
			padding: 0 15px;
			.list {
				box-sizing: border-box;
				padding: 10px 0;
				border-bottom: 1px #E2E2E2 solid;
			}
			.advertising {
				width: 100%;
				height: 90px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px #E2E2E2 solid;
				img {
					width: 94px;
					height: 80px;
				}
				.content {
					flex: 1;
					color: #333;
					margin-left: 10px;
					.question {
						font-size: 15px;
						font-weight: bold;
					}
					.anwser {
						font-size: 13px;
						margin-top: 5px;
					}
				}
				.btn {
					width: 68px;
					height: 30px;
					background: linear-gradient(204deg,rgba(0,194,255,1) 0%,rgba(60,67,236,1) 100%);
					border-radius: 15px;
					line-height: 30px;
					text-align: center;
					font-size: 12px;
					color: #fff;
				}
			}
			.no-more-data {
				width: 100%;
				margin: 20px 0 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				.line-left {
					width: 30px;
					height: 1px;
					background: linear-gradient(90deg,rgba(153,153,153,0) 0%,rgba(153,153,153,1) 100%);
				}
				span {
					font-size: 12px;
					color: #999;
					margin: 0 10px;
				}
				.line-right {
					width: 30px;
					height: 1px;
					background: linear-gradient(270deg,rgba(153,153,153,0) 0%,rgba(153,153,153,1) 100%);
				}
			}
		}
	}

	/deep/ .nut-searchbar .search-input {
		margin-right: 0;
	}
</style>
